import React, { useState } from "react";
import { Button, Col, Container, Form, Image, Row } from "react-bootstrap";
import { NavBar } from "./components/NavBar";
import "font-awesome/css/font-awesome.min.css";
import { Footer } from "./components/Footer";
import { IOID4VCIClientCreateOfferUriResponse } from "@sphereon/ssi-sdk.oid4vci-issuer-rest-client";
import { QRRenderingProps, QRType } from "@sphereon/ssi-sdk.qr-code-generator";
import { IssueStatus, IssueStatusResponse } from "@sphereon/oid4vci-common";
import agent from "../../../agent";
const short = require("short-uuid");

export const MyBookings = () => {
  const [showBookingDetails, setShowBookingDetails] = useState(false);
  const [showBookingForm, setShowBookingForm] = useState(false);
  const [bookingIssued, setBookingIssued] = useState(false);
  const [bookingId, setBookingId] = useState("");
  const [lastName, setLastName] = useState("");
  const [qrData, setQrData] = useState<any>();
  const [uri, setUri] = useState("");
  const [preAuthCode, setPreAuthCode] = useState("");
  const [qrCode, setQrCode] = useState<JSX.Element>();

  const renderingProps: QRRenderingProps = {
    bgColor: "#FBFBFB",
    fgColor: "black",
    level: "L",
    size: 330,
  };

  const handleButtonClick = () => {
    setShowBookingForm(true);
  };

  const handleFormSubmit = () => {
    setShowBookingForm(false);
    setShowBookingDetails(true);
  };

  const generateNewQRCodeForInsurance = async () => {
    const shortUuid = short.generate();
    let today = new Date();

    const uriData: IOID4VCIClientCreateOfferUriResponse =
      await agent.oid4vciClientCreateOfferUri({
        grants: {
          "urn:ietf:params:oauth:grant-type:pre-authorized_code": {
            "pre-authorized_code": shortUuid,
            user_pin_required: false,
          },
        },
        credentialDataSupplierInput: {
          bookingId: bookingId,
          fullName: lastName,
          sendCompanyInvoice: "true",
          companyName: "Netcetera AG",
          hotelName: "Luxury Hotel",
          hotelAddress: "Paradise Street 7, 8606 Shangri La, Utopia",
          checkInDate: new Date().setDate(today.getDate() + 7),
          checkOutDate: new Date().setDate(today.getDate() + 14),
          roomType: "Premium Superior Double Room",
          additionalServices: "breakfast included"
        },
        credentials: ["BookingCredential"],
      });



    const qrState = {
      uri: uriData.uri,
      preAuthCode: shortUuid,
      qrData: {
        object: uriData.uri,
        type: QRType.URI,
        id: "567",
      },
    };
    setUri(uriData.uri);
    setPreAuthCode(shortUuid);
    let dataQR: any= {
      object: uriData.uri,
      type: QRType.URI,
      id: "567",
    };
    setQrData(dataQR);

    agent
      .qrURIElement({
        data: dataQR,
        renderingProps: renderingProps,
      })
      .then((qrCode: JSX.Element) => {
        setQrCode(qrCode);
      });

    const intervalId = setInterval(() => {
      agent
        .oid4vciClientGetIssueStatus({ id: shortUuid! })
        .then((status: IssueStatusResponse) => {
          if (status.status === IssueStatus.CREDENTIAL_ISSUED) {
            clearInterval(intervalId);
            setQrCode(undefined);
            setBookingIssued(true);
          } else if (status.status === IssueStatus.ERROR) {
            // TODO: Add feedback to user
            console.error(status.error);
            clearInterval(intervalId);
          }
        })
        .catch((error: Error) => {
          clearInterval(intervalId);
          console.error(`ERROR: ${error.message}`);
        });
    }, 1000);
  }

  return (
    <Container style={{ maxWidth: "100%", padding: "0px" }}>
      <NavBar />
      <div className="banner-section">
      <Image
          style={{ width: "100%" }}
          src={require("./main-iamge.jpeg")}
        ></Image>
        <div className="content-box">
          <h1 data-animation-in="fadeInUp" data-delay-in="0.3">
            Download Your Verified Booking
          </h1>
          <span
            className="sub-title"
            data-animation-in="fadeInUp"
            data-delay-in="0.1"
          >
            We are pleased to inform you that your hotel booking has been
            successfully verified. To ensure a smooth and convenient check-in
            process, we recommend downloading your verified booking credentials
            and adding them to your digital wallet.
          </span>
          <a
            href="#booking-info"
            className="btn"
            data-animation-in="fadeInUp"
            data-delay-in="0.5"
            onClick={handleButtonClick}
          >
            My Booking
          </a>
        </div>

        {showBookingForm && (
          <div
            style={{
              margin: "10rem 0rem",
              width: "100%"
            }}
          >
            <Row id="booking-info" className="my-5" style={{ height: "100%" }}>
              <h2 className="d-flex justify-content-center align-items-center pb-3" style={{paddingTop: "30px"}}>
                Enter your Booking Information
              </h2>
              <Col
                md={12}
                className="d-flex justify-content-center align-items-center"
              >
                <Form onSubmit={handleFormSubmit} style={{ width: "80%" }}>
                  <Form.Group controlId="formBookingId">
                    <Row className="mb-3 d-flex justify-content-center align-items-center">
                      <Col md={2}>
                        <Form.Label>Booking ID</Form.Label>
                      </Col>
                      <Col md={4}>
                        <Form.Control
                          type="text"
                          value={bookingId}
                          onChange={(e) => setBookingId(e.target.value)}
                          placeholder="Enter your booking ID"
                          required
                        />
                      </Col>
                    </Row>
                    <Row className="mb-3 d-flex justify-content-center align-items-center">
                      <Col md={2}>
                        <Form.Label>Name</Form.Label>
                      </Col>
                      <Col md={4}>
                        <Form.Control
                          type="text"
                          value={lastName}
                          onChange={(e) => setLastName(e.target.value)}
                          placeholder="Enter your name"
                          required
                        />
                      </Col>
                    </Row>
                  </Form.Group>
                  <div className="d-flex justify-content-center align-items-center">
                    <Button variant="primary" type="submit" className="mt-4" onClick={() => generateNewQRCodeForInsurance()}>
                      Submit
                    </Button>
                  </div>
                </Form>
              </Col>
            </Row>
          </div>
        )}

        {showBookingDetails && (
          <div
            style={{
              margin: "2rem 0rem",
              width: "100%",
              paddingLeft: "300px",
              paddingRight: "300px",
              height: "400px",
            }}
          >
            {bookingIssued == false? (
              <Row className="my-5" style={{ height: "100%" }}>
              <Col md={6} className="d-flex align-items-center">
                <div>
                  <h2>Hey there!</h2>
                  <p>
                    We're excited to have you with us. Your verified booking
                    credential is ready to be downloaded. Just scan the QR code
                    on the right with your SSI Wallet to get started and
                    add it to your digital wallet for easy access during your
                    stay.
                  </p>
                </div>
              </Col>
              <Col
                md={6}
                className="text-center booking-details d-flex flex-column justify-content-center align-items-center"
              >
                <div className="qr-code-placeholder">
                <div>{qrCode}</div>
                </div>
              </Col>
            </Row>
            ) : (
              <Row className="my-5" style={{ height: "100%" }}>
              <Col md={12} className="d-flex align-items-center">
                <div>
                  <h2>Thank you for your booking!</h2>
                  <p>
                   Just show your booking credential to our CheckIn Counter for a fast and convenient experience!
                  </p>
                </div>
              </Col>
            </Row>
            )}
            
          </div>
        )}

        <Footer></Footer>
      </div>

      {/*<BannerSection />*/}
    </Container>
  );
};
